import DeviceManager from '../utils/device-manager';
import PushServicesHeightHeaderAdjust from './push-services-height-header';

type TabsPushServicesType = {
    desktopInitialized: boolean,
    mobileInitialized: boolean,
    $tabsMenu: HTMLElement|null,
    $tabsMenuUl: HTMLElement|null,
    $tabsMenuItem: HTMLElement[],
    $tabs: HTMLElement[],
    init(): void,
    initDesktop(): void,
    destroyDesktop(): void,
    initMobile(): void,
    destroyMobile(): void,
    clickTabs(element: HTMLElement): void,
    selectTabs($select: HTMLSelectElement): void,
    createSelectPushServiceTabs(): void,
}

const TabsPushServices: TabsPushServicesType = {
    desktopInitialized: false,
    mobileInitialized: false,
    $tabsMenu: null,
    $tabsMenuUl: null,
    $tabsMenuItem: [],
    $tabs: [],

    init() : void {
        this.$tabsMenu = document.querySelector<HTMLElement>('.wrapper-services-menu-tabs');
        this.$tabsMenuUl = document.querySelector<HTMLElement>('.services-menu-tabs');
        this.$tabsMenuItem = Array.from(document.querySelectorAll<HTMLElement>('.services-menu-tabs li a'));
        this.$tabs = Array.from(document.querySelectorAll<HTMLElement>('.wrapper-services-tab'));

        DeviceManager.addCallback(attr => {
            if (!this.desktopInitialized && DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) {
                this.initDesktop();
            } else if (this.desktopInitialized && !DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) {
                this.destroyDesktop();
            }
            if (this.mobileInitialized && DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) {
                this.destroyMobile();
            } else if (!this.mobileInitialized && !DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) {
                this.initMobile();
            }
        });
    },

    initDesktop() : void {
        this.desktopInitialized = true;
        this.$tabsMenuItem.forEach($element => {
            $element.addEventListener('click', () => {
                this.clickTabs($element);
            });
        });

        if (this.$tabsMenuItem[0]) {
            this.$tabsMenuItem[0].classList.add('active');
        }

        if (this.$tabs[0]) {
            this.$tabs[0].classList.remove('hidden');
        }
    },

    destroyDesktop() : void {
        this.desktopInitialized = false;
        this.$tabsMenuItem.forEach($element => {
            $element.removeEventListener('click', () => {
                this.clickTabs($element);
            });
        });
    },

    initMobile() : void {
        this.mobileInitialized = true;
        this.$tabsMenuUl?.classList.add('hidden');
        this.$tabs[0].classList.remove('hidden');
        this.createSelectPushServiceTabs();
        const $selectTabPushServices = document.querySelector<HTMLSelectElement>('select.select-push-services-tabs');
        $selectTabPushServices?.addEventListener('change', () => {
            this.selectTabs($selectTabPushServices);
        });
    },

    destroyMobile() : void {
        this.mobileInitialized = false;
        this.$tabsMenuUl?.classList.remove('hidden');
        const $selectTabPushServices = document.querySelector<HTMLSelectElement>('select.select-push-services-tabs');
        if ($selectTabPushServices) {
            this.$tabsMenu?.removeChild($selectTabPushServices);
            $selectTabPushServices.removeEventListener('change', () => {
                this.selectTabs($selectTabPushServices);
            });
        }
    },

    clickTabs($element: HTMLElement) : void {
        const dataTab = $element.getAttribute('data-tabs');
        const tabToOpen = document.querySelector('#' + dataTab) as HTMLElement;
        const $tabsMenuItem = document.querySelectorAll('.wrapper-services-menu-tabs li a');
        const $tabs = document.querySelectorAll('.wrapper-services-tab');

        $tabsMenuItem.forEach(element => {
            element.classList.remove('active');
        });
        $tabs.forEach(element => {
            element.classList.add('hidden');
        });

        $element.classList.add('active');
        tabToOpen.classList.remove('hidden');
        PushServicesHeightHeaderAdjust.adjustHeightHeaderServices();
    },

    selectTabs($select: HTMLSelectElement) : void {
        const tabToOpen = document.querySelector('#' + $select.value) as HTMLElement;
        const $tabs = document.querySelectorAll('.wrapper-services-tab');
        $tabs.forEach(element => {
            element.classList.add('hidden');
        });
        tabToOpen.classList.remove('hidden');
    },

    createSelectPushServiceTabs() : void {
        const selectTabPushServices = document.createElement('select');
        this.$tabsMenuItem.forEach($element => {
            const opt = new Option($element.innerHTML, $element.getAttribute('data-tabs') as string);
            selectTabPushServices.options[selectTabPushServices.options.length] = opt;
        });
        selectTabPushServices.classList.add('select-push-services-tabs');
        this.$tabsMenu?.appendChild(selectTabPushServices);
    },
};

export default TabsPushServices;
